import type { DateTimeRange } from '~api/som_search';

import { CalendarDateRange } from '~src/utils/date-schema';

import { CalendarDateTimeRange } from './date-time-schema';

export function startOfDay(date: Date) {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  return start;
}

export function endOfDay(date: Date) {
  const end = new Date(date);
  end.setHours(23, 59, 59, 999);
  return end;
}

export function stringifyDateRange(date?: CalendarDateRange): DateTimeRange | undefined {
  return date?.start && date?.end
    ? { start: `${date.start}T00:00:00.000Z`, end: `${date.end}T23:59:59.999Z` }
    : undefined;
}

export function stringifyDateTimeRange(date?: CalendarDateTimeRange): DateTimeRange | undefined {
  return date?.start && date?.end
    ? { start: new Date(date.start).toISOString(), end: new Date(date.end).toISOString() }
    : undefined;
}
